import { useEffect } from 'react'
import { useConsent } from '@/context/ConsentContext.jsx'
import { useAuth } from '@/context/AuthContext.jsx'
import { advertisingPageFamily } from '@/lib/advertisingPolicy.js'
import { syncGoogleAnalytics } from '@/lib/consentedGoogleAnalytics.js'
import { useLocation } from 'react-router-dom'
import { isPasswordRecoveryRoute } from '@/lib/passwordRecoveryRoutes.js'
import { CookieConsentBanner } from './CookieConsentBanner.jsx'

export default function PageResources() {
  const { pathname } = useLocation()
  const { consent } = useConsent()
  const { user } = useAuth() || {}
  const sensitive = Boolean(window.__visualgSensitiveAuthPage) || isPasswordRecoveryRoute(pathname)
  useEffect(() => {
    if (!sensitive) window.__visualgLoadFonts?.()
  }, [pathname, sensitive])
  useEffect(() => { syncGoogleAnalytics({ consent, user, sensitive, pathname, pageFamily: advertisingPageFamily(pathname) }) }, [consent, user, sensitive, pathname])
  // Recovery pages do not load analytics and need the full mobile viewport.
  if (sensitive) return null
  return <CookieConsentBanner />
}
